import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NavigationLinks from '@cotyorg/ccx-molecules/NavigationLinks';

import AdditionalChildrenListItem from './AdditionalChildrenListItem';
import AdditionalChildren from './AdditionalChildren';

const generateFooterListClasses = extraClass => classNames(
  'navigation',
  'footer-list',
  extraClass,
);

const generateNavListClasses = extraClass => classNames(
  'navigation__list',
  'grid-x',
  'footer-list__nav-list',
  extraClass,
);

const generateNavListItemClasses = extraClass => classNames(
  'cell',
  'auto',
  extraClass,
);

const generateNavLinkClasses = extraClass => classNames(extraClass);

const generateNavClasses = extraClass => classNames(
  'footer-list__nav',
  'flex-container',
  extraClass,
);

const FooterList = ({
  children,
  footer: { pages } = {},
  extraClass,
  extraNavClass,
  extraNavListClass,
  extraNavListItemClass,
  extraNavLinkClass,
  extraChildrenWrapperClass,
  disableNesting,
  forceSectionTitles,
  addChildrenAsLinks,
  navLimit,
  headingLevel,
}) => (
  <div className={generateFooterListClasses(extraClass)}>
    <div className="grid-container">
      <nav className={generateNavClasses(extraNavClass)}>
        <ul className={generateNavListClasses(extraNavListClass)} data-test="footer-list">
          <NavigationLinks
            pages={pages}
            extraClass={generateNavListItemClasses(extraNavListItemClass)}
            linkExtraClass={generateNavLinkClasses(extraNavLinkClass)}
            disableNesting={disableNesting}
            forceSectionTitles={forceSectionTitles}
            navLimit={navLimit}
            headingLevel={headingLevel}
          />
          {
            addChildrenAsLinks && children && (
              <AdditionalChildrenListItem extraClass={extraChildrenWrapperClass}>{children}</AdditionalChildrenListItem>
            )
          }
        </ul>
        {
          !addChildrenAsLinks && children && (
            <AdditionalChildren extraClass={extraChildrenWrapperClass}>{children}</AdditionalChildren>
          )
        }
      </nav>
    </div>
  </div>
);

FooterList.propTypes = {
  footer: PropTypes.shape({
    pages: PropTypes.array.isRequired,
  }).isRequired,
  children: PropTypes.node,
  extraClass: PropTypes.string,
  extraNavClass: PropTypes.string,
  extraNavListClass: PropTypes.string,
  extraNavListItemClass: PropTypes.string,
  extraNavLinkClass: PropTypes.string,
  extraChildrenWrapperClass: PropTypes.string,
  disableNesting: PropTypes.bool,
  forceSectionTitles: PropTypes.bool,
  addChildrenAsLinks: PropTypes.bool,
  navLimit: PropTypes.number,
  headingLevel: PropTypes.number,
};

export default FooterList;
